<template>
  <div id="app" :class="vueAppClasses">
    <router-view @setAppClasses="setAppClasses" />
  </div>
</template>

<script>
import themeConfig from "@/../themeConfig.js";
import Vue from "vue";

var body = document.querySelector("body");
var backgroundTimer = null;

export default {
  data() {
    return {
      vueAppClasses: [],
      bgImages: [
        "background_1",
        "background_2",
        "background_3",
        "background_4",
        "background_5",
        "background_6",
        "background_7",
        "background_8",
        "background_9",
        "background_10",
        "background_11",
        "background_12",
        "background_13",
        "background_14",
        "background_15",
        "background_16",
      ],
      bgImage: "",
    };
  },
  watch: {
    $route(route) {
      if (route.name == "dashboard") {
        clearTimeout(backgroundTimer);
        this.setBodyClass("bg-white");
      } else {
        if (window.innerWidth > 767) {
          this.bgImages = this.bgImages
            .map((value) => ({ value, sort: Math.random() }))
            .sort((a, b) => a.sort - b.sort)
            .map(({ value }) => value);
          this.setBodyClass(this.bgImages[0]);
          this.switchBackground();
        } else {
          clearTimeout(backgroundTimer);
          this.setBodyClass("bg-white");
        }
      }
    },
    "$store.state.theme"(val) {
      this.toggleClassInBody(val);
    },
    "$vs.rtl"(val) {
      document.documentElement.setAttribute("dir", val ? "rtl" : "ltr");
    },
    "$i18n.locale"() {
      this.routeTitle = this.$t(this.$route.meta.pageTitle);

      if (this.routeTitle)
        document.title = this.routeTitle + " | " + this.$t("PageTitle");
      else document.title = this.$t("PageTitle");

      this.$misc.emit("localeEvent");
    },
  },
  async created() {
    try {
      this.$vs.rtl = this.$i18n.locale == "ar" ? true : false;
      let dir = this.$vs.rtl ? "rtl" : "ltr";

      document.documentElement.setAttribute("dir", dir);
      window.addEventListener("resize", this.handleWindowResize);
      window.addEventListener("scroll", this.handleScroll);

      // await this.$auth.renewTokens();
      // Vue.prototype.startSignalR(this.$store.state.auth.userInfo().token);
      // this.$signalr.$on("SoldRentArea", this.soldRentArea);
      // this.$signalr.$on("SoldRentAreaAuth", this.soldRentAreaAuth);
      // this.$signalr.$on("SoldRentAreaNewAuth", this.soldRentAreaNewAuth);
    } catch (e) {}

    if (this.$route.name != "dashboard") {
      if (window.innerWidth > 767) {
        this.bgImages = this.bgImages
          .map((value) => ({ value, sort: Math.random() }))
          .sort((a, b) => a.sort - b.sort)
          .map(({ value }) => value);
        this.setBodyClass(this.bgImages[0]);
        this.switchBackground();
      } else {
        clearTimeout(backgroundTimer);
        this.setBodyClass("bg-white");
      }
    }
  },
  methods: {
    switchBackground() {
      backgroundTimer = setTimeout(() => {
        if (this.$route.name != "dashboard") {
          let currentBg = this.bgImages.shift();
          this.setBodyClass(currentBg);
          this.bgImages.push(currentBg);
          clearTimeout(backgroundTimer);
          this.switchBackground();
        }
      }, 8000);
    },
    handleLoginEvent(payload) {
      // if (payload.loggedIn) {
      //   this.$router.push("/");
      // } else {
      //   this.$router.push("/login");
      // }
    },
    soldRentArea(rentArea) {
      this.$store.dispatch("rent/soldPointer", rentArea);
    },
    soldRentAreaAuth(rentArea) {
      this.$store.dispatch("rent/soldAuthPointer", rentArea);
    },
    soldRentAreaNewAuth(rentArea) {
      this.$store.dispatch("rent/addAuthPointer", rentArea);
    },
    toggleClassInBody(className) {
      if (className == "dark") {
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
        document.body.classList.add("theme-dark");
      } else if (className == "semi-dark") {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        document.body.classList.add("theme-semi-dark");
      } else {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
      }
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr);
    },
    handleWindowResize() {
      this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);
      document.documentElement.style.setProperty(
        "--vh",
        `${window.innerHeight * 0.01}px`
      );

      if (
        this.$route.name != "dashboard" &&
        window.innerWidth > 767 &&
        (body.className == "" || body.className == "bg-white" || !body.className.includes("background_"))
      ) {
        this.bgImages = this.bgImages
          .map((value) => ({ value, sort: Math.random() }))
          .sort((a, b) => a.sort - b.sort)
          .map(({ value }) => value);
        this.setBodyClass(this.bgImages[0]);
        this.switchBackground();
      } else if (window.innerWidth <= 767) {
        clearTimeout(backgroundTimer);
        this.setBodyClass("bg-white");
      }
    },
    setBodyClass(bgClass) {
      let themeClass = '';
      if (document.body.classList.contains('theme-dark')) themeClass = 'theme-dark';
      else if (document.body.classList.contains('theme-semi-dark')) themeClass = 'theme-semi-dark';
      
      body.className = bgClass + (themeClass ? ' ' + themeClass : '');
    },
    handleScroll() {
      this.$store.commit("UPDATE_WINDOW_SCROLL_Y", window.scrollY);
    },
  },
  mounted() {
    this.toggleClassInBody(themeConfig.theme);
    this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleWindowResize);
    clearTimeout(backgroundTimer);

    // this.$signalr.$off("SoldRentArea", this.soldRentArea);
    // this.$signalr.$off("SoldRentAreaAuth", this.soldRentAreaAuth);
    // this.$signalr.$off("SoldRentAreaNewAuth", this.soldRentAreaNewAuth);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleWindowResize);
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
